import { FastlyImage } from '@components/common/image'

type CodingForStudentsProps = {
  title?: string | JSX.Element
  description?: string | JSX.Element
  imagePath?: string
  imageWidth?: number
  imageHeight?: number
  reverse?: boolean
}

const CodingForStudents = ({
  title,
  description,
  imagePath,
  imageWidth,
  imageHeight,
  reverse,
}: CodingForStudentsProps) => {
  return (
    <div className="container space-y-4 text-grey relative my-10 lg:px-3 py-5">
      <h2 className="text-2xl font-600 leading-tight">
        {title ? (
          title
        ) : (
          <>
            Earn{' '}
            <span className="yellow-underline">AI & coding certifications</span>{' '}
            that make you stand out
          </>
        )}
      </h2>
      <div
        className={`flex flex-col-reverse xl:flex-row${
          reverse ? '-reverse' : ''
        } items-center lg:items-start xl:items-center gap-5 justify-between`}
      >
        <p className="lg:text-lg w-full xl:w-9/12 text-left">
          {description
            ? description
            : "Our young learners from grades 1-12 earn STEM.org-accredited AI & coding certificates that celebrate their achievements while unlocking special badges and leaderboard rankings, making programming a fun and rewarding experience. Our curriculum allows students to earn a variety of certifications, including specializations like Young Scratch Developer, Young Python Programmer, Young Web Developer, Young AI Programmer, Advanced AI Programmer, Java Developer, AP Computer Science A Champion, and AI & Coding Champion. For those looking to dive deeper, students can enroll in advanced courses and earn certifications such as AI & Coding Grandmaster and AI & Coding Prodigy. These certifications are easy to download and share, are STEM.org accredited, and can be added to your child's learning portfolio for sharing with the world and on social media."}
        </p>
        <FastlyImage
          src={
            imagePath
              ? `${imagePath}.png`
              : `/images/home/student-certificate.png`
          }
          alt="Coding Certificate"
          webpSrc={
            imagePath
              ? `${imagePath}.webp`
              : `/images/home/student-certificate.webp`
          }
          width={imageWidth ? imageWidth : 438}
          height={imageHeight ? imageHeight : 375}
        />
      </div>
    </div>
  )
}

export default CodingForStudents
